import { getConfig } from "@borealis/image";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { ReactElement } from "react";

type EmptyType = "noSearch" | "noChildren" | "extendedEmptyInherited";

type EmptyMessageProps = {
	type: EmptyType;
};

type Item = {
	title: string;
	line1: string | ReactElement;
	line2?: string;
};

export const EmptyMessage = ({ type }: EmptyMessageProps) => {
	const emptyItems: Record<EmptyType, Item> = {
		noSearch: {
			title: t`Nothing here!`,
			line1: t`We couldn't find any organizations matching your selected criteria.`,
			line2: t`Please try searching again.`,
		},
		noChildren: {
			title: t`This organization has no sub-companies that can be connected`,
			line1: (
				<Trans>
					Contact <a href="mailto:jobb.finn@vend.com">jobb.finn@vend.com</a> if this needs to be updated.
				</Trans>
			),
		},
		extendedEmptyInherited: {
			title: t`Waiting for setup from main account`,
			line1: t`Extended profile must be set up by the main account before you can use it. Once`,
			line2: t`that is done, you can activate the extended profile here.`,
		},
	};

	return (
		<div className="flex flex-col h-[368] gap-32 items-center justify-center">
			<img alt="empty-box" src={`${getConfig().base}/emptyBox.svg`} />
			<div className="flex flex-col max-w-576 gap-8 text-center">
				<h4 className="mb-0">{emptyItems[type].title}</h4>
				<div className="text-caption">
					<p className="mb-0">{emptyItems[type].line1}</p>
					{emptyItems[type].line2 && <p className="mb-0">{emptyItems[type].line2}</p>}
				</div>
			</div>
		</div>
	);
};
